import { useMutation } from '@apollo/client';

import { UNCONFIRM_USER_HERE } from '../graphql/mutation/unconfirmUserHereMutation.graphql';
import { useCurrentEventQuery } from './useCurrentEventQuery';

export const useUnconfirmUserHereMutation = () => {
  const { data: currentEvent } = useCurrentEventQuery();
  const [mutate] = useMutation(UNCONFIRM_USER_HERE);

  const unconfirmUserHere = (userId: string) => {
    const eventId = currentEvent?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    mutate({
      variables: {
        userId,
        eventId,
      },
    });
  };

  return { unconfirmUserHere };
};
